/**
 * Reads the download filename out of a `Content-Disposition` response header.
 * Handles both `filename="name.xlsx"` and the RFC 5987 `filename*=UTF-8''name.xlsx`
 * form, preferring the latter when the header carries both.
 */
export const extractFilenameFromHeader = (contentDisposition: string | null | undefined): string | null => {
  if (!contentDisposition) return null;
  const match =
    /filename\*=(?:UTF-8'')?["']?([^"';\n]+)["']?/i.exec(contentDisposition) ??
    /filename=["']?([^"';\n]+)["']?/i.exec(contentDisposition);
  if (!match) return null;
  const filename = match[1].trim();
  try {
    return decodeURIComponent(filename);
  } catch {
    // Malformed percent-encoding — the raw value is still a usable filename.
    return filename;
  }
};
